
import Vue from 'vue';

type FormRule = (val?: string) => boolean | string;

type Data = {
  isMenu: boolean;
  temptime: string;
  timeFormatRule: Array<FormRule>;
};

export default Vue.extend({
  name: 'audit-history-time-picker',
  props: {
    label: {
      type: String,
    },
    limited: {
      type: Boolean,
      default: true,
    },
    time: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    min() {
      if (this.limited) {
        return '8:00';
      }
      return '0:00';
    },
    max() {
      if (this.limited) {
        return '20:00';
      }
      return '24:00';
    },
  },
  data: (): Data => ({
    isMenu: false,
    timeFormatRule: [(val?: string) => !!val || '時間を入力してください'],
    temptime: '',
  }),
  methods: {
    allowedStep: (m: number) => m % 5 === 0,
    updateTime() {
      this.isMenu = false;
      this.$emit('update:time', this.temptime);
    },
  },
});
